var _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrderSuccessfull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-17",
    cx: 250,
    cy: 367.69,
    rx: 244.94,
    ry: 123.89,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-17",
    cx: 110.48,
    cy: 400.09,
    rx: 71.75,
    ry: 41.43,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-17",
    d: "M465.43,355,347.6,287.17a7.94,7.94,0,0,0-7.2,0L166,387.89c-2,1.14-2,3,0,4.15l117.83,67.83a7.94,7.94,0,0,0,7.2,0L465.43,359.15C467.42,358,467.42,356.14,465.43,355Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cart--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cargo-car--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.14,114.07l70,40.44c5,2.87,9,9.91,9,15.65v138.2l5.94,3.44V169.62c0-8.1-5.74-18-12.75-22.09l-72.52-41.89c-7-4-12.75-.73-12.75,7.37V255.18l6,3.46V118.13C350.1,113.66,353.27,111.83,357.14,114.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.13,422.9c0-7.28,5.12-16.14,11.43-19.78,3.31-1.92,6.28-2,8.37-.6h0l7.7,4.4-16.38,27.85-7.64-4.4v0C304.48,429.19,303.13,426.62,303.13,422.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.56,407.73c-6.31,3.64-11.43,12.5-11.43,19.78s5.12,10.24,11.43,6.6S334,421.61,334,414.32,328.87,404.08,322.56,407.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.43,418.68c0-2.84-1.74-4.15-3.87-2.92s-3.87,4.54-3.87,7.39,1.73,4.16,3.87,2.92S326.43,421.53,326.43,418.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.17,395.57s0,13,6.22,17.65c1.17.87,2.41,1.47,3.14,2.08,1.59,1.32.54,3.74-1.39,4.78-2.8,1.5-18.05-2.56-24.51-15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,399s0,13,6.22,17.65c1.17.87,2.41,1.47,3.15,2.08,1.58,1.32.53,3.75-1.4,4.78-2.8,1.5-18.05-2.56-24.51-15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.56,419.65a2.42,2.42,0,0,0-1.1,1.9c0,.7.49,1,1.1.63a2.43,2.43,0,0,0,1.09-1.9C323.65,419.59,323.16,419.3,322.56,419.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.17,351.29c0-7.29,5.12-16.15,11.43-19.79,3.31-1.91,6.28-2,8.37-.59h0l7.7,4.4-16.38,27.84-7.64-4.39v0C428.52,357.58,427.17,355,427.17,351.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.6,336.11c-6.31,3.64-11.43,12.5-11.43,19.79s5.12,10.24,11.43,6.6S458,350,458,342.71,452.91,332.47,446.6,336.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.47,347.07c0-2.85-1.74-4.16-3.87-2.92s-3.87,4.54-3.87,7.39,1.73,4.15,3.87,2.92S450.47,349.92,450.47,347.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.21,324s0,13,6.22,17.65c1.17.87,2.41,1.47,3.14,2.08,1.59,1.32.54,3.75-1.39,4.78-2.8,1.5-18.05-2.56-24.51-15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.13,327.35s0,13,6.22,17.65c1.17.87,2.41,1.47,3.15,2.09,1.58,1.31.53,3.74-1.4,4.77-2.8,1.5-18.05-2.56-24.51-15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.6,348a2.42,2.42,0,0,0-1.1,1.9c0,.69.49,1,1.1.63a2.43,2.43,0,0,0,1.09-1.9C447.69,348,447.2,347.69,446.6,348Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.13 315.25 338.13 251.73 158.42 355.48 268.41 419.01 448.13 315.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.13 315.25 448.13 322.16 268.41 425.92 268.41 419.01 448.13 315.25",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.42 355.48 158.42 362.39 268.41 425.92 268.41 419.01 158.42 355.48",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-17",
    points: "432.14 315.55 337.8 370.04 241.58 314.56 336.18 260.21 432.14 315.55",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "428.93 250.76 342.53 200.79 251.22 253.64 337.62 303.61 428.93 250.76",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.93 250.76 342.53 200.79 251.22 253.64 337.62 303.61 428.93 250.76",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.62 364 428.93 311.16 428.93 250.76 337.62 303.61 337.62 364",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.62 364 428.93 311.16 428.93 250.76 337.62 303.61 337.62 364",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.7,344a1.56,1.56,0,0,1-.79-.21,2.39,2.39,0,0,1-1-2.17v-6.4h0v-.47l.33.06,5-2.95V339a5.77,5.77,0,0,1-2.47,4.67A2.18,2.18,0,0,1,347.7,344Zm-1-8.3v5.92a1.67,1.67,0,0,0,.57,1.48,1.16,1.16,0,0,0,1.09-.12,5.08,5.08,0,0,0,2.07-4v-.52h-1.86l-.36-2.51Zm2.57,2h1.16v-4.42l-3,1.76,1.48.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.6,349.07a.4.4,0,0,1-.4-.4v-5.38a.4.4,0,1,1,.8,0v5.38A.4.4,0,0,1,348.6,349.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,350.42a.39.39,0,0,1-.35-.2.4.4,0,0,1,.14-.55l4.68-2.7a.4.4,0,0,1,.55.15.41.41,0,0,1-.15.55l-4.67,2.7A.53.53,0,0,1,346.27,350.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.92,341.16a1,1,0,0,1-.45-.11,1.08,1.08,0,0,1-.48-1V339a.41.41,0,0,1,.81,0v1.1c0,.17,0,.25.08.27s.12,0,.26-.07a2.39,2.39,0,0,0,.75-1.82v-7.15a.4.4,0,0,1,.8,0v7.15a3.06,3.06,0,0,1-1.14,2.51A1.23,1.23,0,0,1,362.92,341.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.68,334.91v-.7a11.38,11.38,0,0,1,5.14-8.91,3.4,3.4,0,0,1,5.55,3.2v.23Zm7.55-9.54a4.06,4.06,0,0,0-2,.63,10.63,10.63,0,0,0-4.7,7.5l9-5.23a3,3,0,0,0-1.24-2.62A2.11,2.11,0,0,0,366.23,325.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.36,332.92a.4.4,0,0,1-.4-.4V318.83a.41.41,0,0,1,.81,0v13.69A.4.4,0,0,1,377.36,332.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.19,322a.41.41,0,0,1-.16,0,.4.4,0,0,1-.21-.53l1.43-3.31,1.6,1.85a.4.4,0,0,1-.61.52l-.76-.87-.92,2.13A.41.41,0,0,1,376.19,322Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.09,330.8a.4.4,0,0,1-.41-.4V316.71a.41.41,0,1,1,.81,0V330.4A.4.4,0,0,1,381.09,330.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.91,319.83a.41.41,0,0,1-.16,0,.4.4,0,0,1-.21-.53L381,316l1.6,1.84a.4.4,0,1,1-.61.53l-.76-.88-.92,2.14A.41.41,0,0,1,379.91,319.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.62 364 251.22 314.04 251.22 253.64 337.62 303.61 337.62 364",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.62 364 251.22 314.04 251.22 253.64 337.62 303.61 337.62 364",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.49 283.76 293.41 287.17 293.41 277.99 287.49 274.58 287.49 283.76",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.41 278 384.72 225.15 378.8 221.73 287.49 274.58 293.41 278",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.17 273.02 296.08 276.44 299.38 274.54 293.47 271.12 290.17 273.02",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,232.85l-24.19,13.93c-.44.26-.32.73.26,1.07l27.31,15.77a2.12,2.12,0,0,0,1.85.15l24.19-13.94c.44-.25.32-.73-.26-1.07L386.8,233A2.09,2.09,0,0,0,385,232.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.17,256.56a.5.5,0,0,0,.43-.25.5.5,0,0,0-.18-.68l-22.68-13.09a.5.5,0,0,0-.5.86l22.68,13.09A.43.43,0,0,0,397.17,256.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.65,258a.5.5,0,0,0,.25-.93L372.23,244a.51.51,0,0,0-.69.18.52.52,0,0,0,.19.69l22.67,13.08A.45.45,0,0,0,394.65,258Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.13,259.44a.5.5,0,0,0,.25-.93l-22.67-13.09a.5.5,0,0,0-.5.87l22.67,13.09A.57.57,0,0,0,392.13,259.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.61,260.89a.51.51,0,0,0,.44-.25.52.52,0,0,0-.19-.69l-22.67-13.08a.5.5,0,1,0-.5.86l22.67,13.09A.47.47,0,0,0,389.61,260.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.09 249.2 411.2 248.69 400.88 254.65 401.76 255.16 412.09 249.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.5 247.13 406.97 246.25 396.64 252.22 398.17 253.09 408.5 247.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.91 245.05 404.03 244.54 393.7 250.51 394.58 251.01 404.91 245.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.22 243.48 400.44 242.47 390.11 248.43 391.89 249.44 402.22 243.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.73 240.91 396.85 240.4 386.52 246.36 387.4 246.87 397.73 240.91",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.17 239.4 393.26 238.32 382.93 244.29 384.84 245.37 395.17 239.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.56 236.76 389.67 236.25 379.35 242.22 380.23 242.72 390.56 236.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.52 235.57 388.08 235.32 377.75 241.28 378.19 241.54 388.52 235.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.14 237.74 391.7 237.48 381.37 243.44 381.81 243.7 392.14 237.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.41 241.89 398.97 241.63 388.64 247.6 389.08 247.85 399.41 241.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.36 244.18 402.92 243.92 392.59 249.89 393.03 250.14 403.36 244.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.16 245.85 405.72 245.59 395.39 251.56 395.83 251.81 406.16 245.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.09 248.03 409.65 247.78 399.32 253.74 399.76 253.99 410.09 248.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.97 234.69 386.08 234.18 375.76 240.14 376.64 240.65 386.97 234.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.88,305.15V320.3c0,.58.41.82.92.53l23.65-13.66a2,2,0,0,0,.91-1.58V290.43c0-.58-.41-.82-.91-.53l-23.65,13.67A2,2,0,0,0,400.88,305.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.89 292.07 424.13 292.51 424.13 306.28 424.89 305.84 424.89 292.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.78 293.87 420.46 294.64 420.46 308.41 421.78 307.64 421.78 293.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.67 295.66 417.91 296.1 417.91 309.87 418.67 309.43 418.67 295.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.33 296.99 414.8 297.89 414.8 311.67 416.33 310.76 416.33 296.99",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.45 299.25 411.69 299.69 411.69 313.46 412.45 313.02 412.45 299.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.22 300.51 408.58 301.48 408.58 315.25 410.22 314.28 410.22 300.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.24 302.83 405.48 303.28 405.48 317.05 406.24 316.61 406.24 302.83",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.46 303.84 404.08 304.06 404.08 317.83 404.46 317.62 404.46 303.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.66 302.08 407.27 302.31 407.27 316.08 407.66 315.86 407.66 302.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.92 298.42 413.54 298.64 413.54 312.41 413.92 312.19 413.92 298.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.35 296.45 416.96 296.67 416.96 310.44 417.35 310.22 417.35 296.45",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.81 295.09 419.43 295.31 419.43 309.08 419.81 308.86 419.81 295.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.15 293.06 422.77 293.28 422.77 307.05 423.15 306.83 423.15 293.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.13 304.63 402.37 305.07 402.37 318.84 403.13 318.4 403.13 304.63",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-17",
    points: "423.06 249.48 339.23 297.93 250.56 246.63 334.38 198.18 423.06 249.48",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "248.25 181.02 328.67 134.51 419.66 187.16 339.25 233.67 248.25 181.02",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.25 181.02 328.67 134.51 419.66 187.16 339.25 233.67 248.25 181.02",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.79,164.55,311,178.48c.44.25.32.73-.26,1.07l-27.31,15.76a2.09,2.09,0,0,1-1.85.16l-24.19-13.94c-.44-.26-.32-.73.26-1.07L285,164.7A2,2,0,0,1,286.79,164.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.58,188.26a.52.52,0,0,1-.44-.25.5.5,0,0,1,.19-.68L297,174.24a.5.5,0,1,1,.5.86l-22.67,13.09A.47.47,0,0,1,274.58,188.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.09,189.7a.5.5,0,0,1-.43-.25.5.5,0,0,1,.18-.68l22.68-13.09a.5.5,0,1,1,.5.86l-22.68,13.09A.43.43,0,0,1,277.09,189.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.61,191.14a.5.5,0,0,1-.25-.93L302,177.12a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-22.67,13.09A.54.54,0,0,1,279.61,191.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,192.58a.48.48,0,0,1-.43-.25.5.5,0,0,1,.18-.68l22.67-13.09a.5.5,0,0,1,.5.87l-22.67,13.09A.57.57,0,0,1,282.13,192.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.66 180.9 260.54 180.39 270.87 186.35 269.98 186.86 259.66 180.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.25 178.82 264.77 177.95 275.1 183.91 273.57 184.79 263.25 178.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.83 176.75 267.72 176.24 278.04 182.2 277.16 182.71 266.83 176.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.52 175.18 271.3 174.17 281.63 180.13 279.85 181.14 269.52 175.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.01 172.6 274.89 172.1 285.22 178.06 284.34 178.57 274.01 172.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.57 171.1 278.48 170.02 288.81 175.99 286.9 177.06 276.57 171.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.19 168.46 282.07 167.95 292.4 173.91 291.51 174.42 281.19 168.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.23 167.27 283.67 167.02 293.99 172.98 293.55 173.23 283.23 167.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.6 169.43 280.04 169.18 290.37 175.14 289.93 175.4 279.6 169.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.33 173.59 272.77 173.33 283.1 179.29 282.66 179.55 272.33 173.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.38 175.88 268.82 175.62 279.15 181.59 278.71 181.84 268.38 175.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.58 177.55 266.03 177.29 276.35 183.25 275.91 183.51 265.58 177.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.65 179.73 262.1 179.47 272.42 185.44 271.98 185.69 261.65 179.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.78 166.39 285.66 165.88 295.99 171.84 295.1 172.35 284.78 166.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.25 294.07 248.25 241.42 248.25 181.02 339.25 233.67 339.25 294.07",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.25 294.07 419.66 247.56 419.66 187.16 339.25 233.67 339.25 294.07",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.25 294.07 419.66 247.56 419.66 187.16 339.25 233.67 339.25 294.07",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.39 217.28 377.48 220.69 377.48 211.51 383.39 208.1 383.39 217.28",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.48 211.52 286.48 158.87 292.39 155.45 383.39 208.1 377.48 211.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.89,265.18a5,5,0,0,1-2.11-4v-6.12l4.29,2.52.28,0V258h0v5.47a2,2,0,0,1-.84,1.85,1.29,1.29,0,0,1-.67.18A2,2,0,0,1,305.89,265.18Zm.48-6.59-.31,2.15h-1.59v.45a4.32,4.32,0,0,0,1.77,3.39.94.94,0,0,0,.93.11,1.41,1.41,0,0,0,.49-1.26v-5.07Zm-.61-.59,1.27-.22-2.56-1.51v3.78h1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.07,269.82a.34.34,0,0,0,.34-.34v-4.6a.34.34,0,0,0-.34-.34.35.35,0,0,0-.35.34v4.6A.35.35,0,0,0,306.07,269.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.06,271a.34.34,0,0,0,.18-.64l-4-2.31a.34.34,0,1,0-.34.6l4,2.3A.3.3,0,0,0,308.06,271Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,278.07a.82.82,0,0,0,.38-.09.93.93,0,0,0,.41-.83v-.94a.35.35,0,0,0-.34-.35.35.35,0,0,0-.35.35v.94a.34.34,0,0,1-.06.23.32.32,0,0,1-.23-.06,2,2,0,0,1-.64-1.55v-6.11a.35.35,0,0,0-.34-.35.35.35,0,0,0-.35.35v6.11a2.61,2.61,0,0,0,1,2.14A1,1,0,0,0,320,278.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.51,267.45v-.2a2.92,2.92,0,0,1,4.75-2.74,9.74,9.74,0,0,1,4.39,7.62v.6Zm1.76-2.64a2.56,2.56,0,0,0-1.07,2.25l7.73,4.46a9.07,9.07,0,0,0-4-6.41,3.51,3.51,0,0,0-1.71-.53A1.89,1.89,0,0,0,316.27,264.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.86,285.78a.34.34,0,0,0,.34-.34v-11.7a.34.34,0,0,0-.34-.34.35.35,0,0,0-.35.34v11.7A.35.35,0,0,0,333.86,285.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86,276.41a.35.35,0,0,0,.32-.48L334,273.1l-1.36,1.58a.34.34,0,0,0,0,.48.36.36,0,0,0,.49,0l.65-.75.79,1.82A.34.34,0,0,0,334.86,276.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.67,284a.35.35,0,0,0,.35-.34v-11.7a.35.35,0,0,0-.35-.35.35.35,0,0,0-.34.35v11.7A.34.34,0,0,0,330.67,284Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.68,274.59a.34.34,0,0,0,.14,0,.36.36,0,0,0,.18-.46l-1.23-2.82-1.36,1.57a.34.34,0,1,0,.52.45l.65-.75.79,1.83A.33.33,0,0,0,331.68,274.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,236V251.1c0,.58-.41.82-.92.53L251.47,238a2.06,2.06,0,0,1-.91-1.59V221.23c0-.58.41-.82.92-.52l23.64,13.66A2,2,0,0,1,276,236Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.03 222.88 252.79 223.32 252.79 237.09 252.03 236.65 252.03 222.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.13 224.67 256.45 225.44 256.45 239.21 255.13 238.44 255.13 224.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.24 226.46 259 226.9 259 240.67 258.24 240.23 258.24 226.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.58 227.79 262.11 228.7 262.11 242.47 260.58 241.56 260.58 227.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.46 230.05 265.22 230.49 265.22 244.26 264.46 243.82 264.46 230.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.7 231.31 268.33 232.28 268.33 246.06 266.7 245.08 266.7 231.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.68 233.64 271.44 234.08 271.44 247.85 270.68 247.41 270.68 233.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.45 234.65 272.83 234.87 272.83 248.64 272.45 248.42 272.45 234.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.26 232.89 269.64 233.11 269.64 246.88 269.26 246.66 269.26 232.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263 229.22 263.38 229.44 263.38 243.21 263 242.99 263 229.22",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.57 227.25 259.95 227.47 259.95 241.24 259.57 241.02 259.57 227.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.1 225.89 257.49 226.11 257.49 239.88 257.1 239.66 257.1 225.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.76 223.87 254.15 224.09 254.15 237.85 253.76 237.63 253.76 223.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.78 235.43 274.55 235.87 274.55 249.64 273.78 249.2 273.78 235.43",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-17",
    points: "246.81 180.19 333.96 230.62 402.25 191.19 314.95 140.78 246.81 180.19",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "242.78 152.66 315.9 110.45 401.2 159.7 328.08 201.91 242.78 152.66",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.78 152.66 315.9 110.45 401.2 159.7 328.08 201.91 242.78 152.66",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.33,136.19l24.18,13.93c.44.26.32.73-.26,1.07L277.94,167a2.12,2.12,0,0,1-1.85.15L251.9,153.17c-.44-.25-.32-.73.26-1.07l27.32-15.76A2.09,2.09,0,0,1,281.33,136.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.11,159.9a.5.5,0,0,1-.25-.93l22.67-13.09a.5.5,0,1,1,.5.86l-22.67,13.09A.47.47,0,0,1,269.11,159.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.63,161.34a.5.5,0,0,1-.25-.93l22.67-13.09a.5.5,0,0,1,.68.18.51.51,0,0,1-.18.69l-22.67,13.08A.47.47,0,0,1,271.63,161.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,162.78a.5.5,0,0,1-.25-.93l22.67-13.09a.5.5,0,1,1,.5.87l-22.67,13.09A.54.54,0,0,1,274.14,162.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.66,164.23a.5.5,0,0,1-.43-.25.51.51,0,0,1,.18-.69l22.67-13.08a.5.5,0,1,1,.5.86l-22.67,13.09A.47.47,0,0,1,276.66,164.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.19 152.54 255.07 152.03 265.4 157.99 264.51 158.5 254.19 152.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.77 150.47 259.31 149.59 269.63 155.56 268.1 156.43 257.77 150.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.36 148.39 262.25 147.88 272.57 153.85 271.69 154.35 261.36 148.39",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.05 146.82 265.83 145.81 276.16 151.77 274.38 152.78 264.05 146.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.54 144.25 269.42 143.74 279.75 149.7 278.87 150.21 268.54 144.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.1 142.74 273.01 141.66 283.34 147.63 281.43 148.71 271.1 142.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.72 140.1 276.6 139.59 286.93 145.56 286.05 146.06 275.72 140.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.75 138.91 278.2 138.66 288.52 144.62 288.08 144.88 277.75 138.91",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.13 141.08 274.57 140.82 284.9 146.78 284.46 147.04 274.13 141.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.86 145.23 267.31 144.97 277.63 150.94 277.19 151.19 266.86 145.23",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.91 147.52 263.36 147.26 273.68 153.23 273.24 153.48 262.91 147.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.12 149.19 260.56 148.93 270.88 154.9 270.44 155.15 260.12 149.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.19 151.37 256.63 151.12 266.95 157.08 266.51 157.33 256.19 151.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.31 138.03 280.19 137.52 290.52 143.48 289.63 143.99 279.31 138.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.08 230.06 242.78 180.81 242.78 152.66 328.08 201.91 328.08 230.06",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "328.08 230.06 242.78 180.81 242.78 152.66 328.08 201.91 328.08 230.06"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "328.08 230.06 401.2 187.84 401.2 159.7 328.08 201.91 328.08 230.06",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.08 230.06 401.2 187.84 401.2 159.7 328.08 201.91 328.08 230.06",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.23 185.52 366.31 188.93 366.31 179.76 372.23 176.34 372.23 185.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.31 179.76 281.01 130.51 286.92 127.09 372.23 176.34 366.31 179.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.73,201.16a4.94,4.94,0,0,1-2.11-4v-6.11l4.29,2.52.28-.05v.4h0v5.47a2.06,2.06,0,0,1-.84,1.86,1.31,1.31,0,0,1-.67.17A1.88,1.88,0,0,1,294.73,201.16Zm.48-6.58-.32,2.14h-1.58v.45a4.34,4.34,0,0,0,1.77,3.4.94.94,0,0,0,.92.1,1.39,1.39,0,0,0,.5-1.26v-5.06Zm-.61-.59,1.27-.23-2.56-1.5V196h1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.9,205.8a.35.35,0,0,0,.35-.34v-4.59a.35.35,0,0,0-.35-.35.35.35,0,0,0-.34.35v4.59A.34.34,0,0,0,294.9,205.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.9,207a.33.33,0,0,0,.3-.18.35.35,0,0,0-.13-.47l-4-2.3a.34.34,0,0,0-.47.13.33.33,0,0,0,.12.46l4,2.31A.34.34,0,0,0,296.9,207Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.87,214.06a.79.79,0,0,0,.37-.1.9.9,0,0,0,.42-.83v-.94a.35.35,0,0,0-.35-.34.34.34,0,0,0-.34.34v.94c0,.14,0,.22-.07.23s-.1,0-.22-.06a2,2,0,0,1-.64-1.55v-6.11a.34.34,0,0,0-.34-.34.35.35,0,0,0-.35.34v6.11a2.62,2.62,0,0,0,1,2.15A1.12,1.12,0,0,0,308.87,214.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.35,203.44v-.2a2.91,2.91,0,0,1,4.74-2.74,9.73,9.73,0,0,1,4.4,7.62v.6Zm1.75-2.64A2.56,2.56,0,0,0,304,203l7.73,4.46a9,9,0,0,0-4-6.4,3.46,3.46,0,0,0-1.72-.54A1.84,1.84,0,0,0,305.1,200.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.69,221.77a.35.35,0,0,0,.35-.34V209.72a.35.35,0,0,0-.35-.34.34.34,0,0,0-.34.34v11.71A.34.34,0,0,0,322.69,221.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.7,212.39a.31.31,0,0,0,.13,0,.33.33,0,0,0,.18-.45l-1.22-2.82-1.37,1.57a.35.35,0,0,0,0,.49.34.34,0,0,0,.48,0l.65-.75.79,1.83A.36.36,0,0,0,323.7,212.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,220a.35.35,0,0,0,.35-.35v-11.7a.35.35,0,0,0-.35-.34.34.34,0,0,0-.34.34v11.7A.35.35,0,0,0,319.51,220Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.52,210.58a.31.31,0,0,0,.13,0,.33.33,0,0,0,.18-.45l-1.22-2.83-1.37,1.58a.35.35,0,0,0,0,.48.33.33,0,0,0,.48,0l.65-.75.79,1.82A.36.36,0,0,0,320.52,210.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.57,175.34v15.15c0,.58-.41.82-.91.53L246,177.36a2,2,0,0,1-.92-1.58V160.62c0-.58.41-.82.92-.53l23.64,13.66A2,2,0,0,1,270.57,175.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.56 162.26 247.32 162.7 247.32 176.47 246.56 176.03 246.56 162.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.66 164.06 250.98 164.83 250.98 178.6 249.66 177.82 249.66 164.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.77 165.85 253.54 166.29 253.54 180.06 252.77 179.62 252.77 165.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.12 167.18 256.64 168.08 256.64 181.85 255.12 180.95 255.12 167.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.99 169.44 259.75 169.88 259.75 183.65 258.99 183.21 258.99 169.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.23 170.7 262.86 171.67 262.86 185.44 261.23 184.47 261.23 170.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.21 173.02 265.97 173.47 265.97 187.24 265.21 186.79 265.21 173.02",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.98 174.03 267.36 174.25 267.36 188.02 266.98 187.8 266.98 174.03",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.79 172.27 264.17 172.5 264.17 186.26 263.79 186.04 263.79 172.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.53 168.61 257.91 168.83 257.91 182.6 257.53 182.38 257.53 168.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.1 166.64 254.48 166.86 254.48 180.63 254.1 180.41 254.1 166.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.64 165.28 252.02 165.5 252.02 179.27 251.64 179.05 251.64 165.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.3 163.25 248.68 163.47 248.68 177.24 248.3 177.02 248.3 163.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.31 174.82 269.08 175.26 269.08 189.03 268.31 188.59 268.31 174.82",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-17",
    points: "283.53 344.76 216.72 383.29 166.71 354.38 233.68 315.94 283.53 344.76",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "172.81 231.24 233.74 196.07 278.43 221.86 217.5 257.04 172.81 231.24",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.81 231.24 233.74 196.07 278.43 221.86 217.5 257.04 172.81 231.24",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,201.12l-18.7,10.77c-.34.2-.25.57.2.83l21.12,12.19a1.62,1.62,0,0,0,1.42.12l18.71-10.78c.34-.2.25-.56-.2-.83l-21.12-12.18A1.64,1.64,0,0,0,233.15,201.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6,219.45a.37.37,0,0,0,.33-.19.39.39,0,0,0-.14-.53l-17.53-10.12a.4.4,0,0,0-.53.15.39.39,0,0,0,.14.52L242.4,219.4A.35.35,0,0,0,242.6,219.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.65,220.57a.39.39,0,0,0,.33-.19.38.38,0,0,0-.14-.53l-17.53-10.12a.37.37,0,0,0-.52.14.38.38,0,0,0,.14.53l17.53,10.12A.41.41,0,0,0,240.65,220.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7,221.68a.39.39,0,0,0,.2-.72l-17.53-10.12a.4.4,0,0,0-.53.14.39.39,0,0,0,.14.53l17.53,10.12A.34.34,0,0,0,238.7,221.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.76,222.8a.39.39,0,0,0,.33-.19.38.38,0,0,0-.14-.53L219.42,212a.37.37,0,0,0-.52.14.38.38,0,0,0,.14.53l17.52,10.12A.49.49,0,0,0,236.76,222.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.13 213.76 253.45 213.37 245.47 217.98 246.15 218.37 254.13 213.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.36 212.16 250.17 211.49 242.19 216.1 243.37 216.77 251.36 212.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.58 210.56 247.9 210.16 239.92 214.77 240.6 215.17 248.58 210.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.5 209.34 245.13 208.56 237.14 213.17 238.52 213.95 246.5 209.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.03 207.35 242.35 206.96 234.37 211.57 235.05 211.96 243.03 207.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.05 206.19 239.58 205.36 231.59 209.97 233.07 210.8 241.05 206.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.48 204.15 236.8 203.75 228.82 208.36 229.5 208.76 237.48 204.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.91 203.23 235.57 203.03 227.59 207.64 227.93 207.84 235.91 203.23",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.71 204.9 238.37 204.7 230.38 209.31 230.73 209.51 238.71 204.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.33 208.11 243.99 207.91 236 212.52 236.35 212.72 244.33 208.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.38 209.88 247.04 209.69 239.06 214.29 239.4 214.49 247.38 209.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.55 211.17 249.21 210.97 241.22 215.59 241.56 215.78 249.55 211.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.59 212.86 252.25 212.66 244.26 217.27 244.6 217.47 252.59 212.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.71 202.54 234.03 202.15 226.04 206.76 226.72 207.16 234.71 202.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.5 379.01 172.81 353.21 172.81 231.24 217.5 257.04 217.5 379.01",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.5 379.01 172.81 353.21 172.81 231.24 217.5 257.04 217.5 379.01"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "217.5 379.01 278.43 343.83 278.43 221.86 217.5 257.04 217.5 379.01",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.5 379.01 278.43 343.83 278.43 221.86 217.5 257.04 217.5 379.01",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.99 247.46 244.08 250.87 244.08 241.69 249.99 238.28 249.99 247.46",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.08 241.69 199.4 215.9 205.31 212.48 249.99 238.28 244.08 241.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.14,350.12a5,5,0,0,1-2.11-4V340l4.29,2.52.28,0v.41h0v5.47a2,2,0,0,1-.84,1.85,1.29,1.29,0,0,1-.67.18A2,2,0,0,1,184.14,350.12Zm.48-6.59-.31,2.15h-1.59v.45a4.32,4.32,0,0,0,1.77,3.39.94.94,0,0,0,.93.11,1.42,1.42,0,0,0,.49-1.26V343.3Zm-.61-.59,1.27-.22-2.56-1.51V345h1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.32,354.76a.34.34,0,0,0,.34-.34v-4.6a.34.34,0,0,0-.34-.34.35.35,0,0,0-.35.34v4.6A.35.35,0,0,0,184.32,354.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.31,355.91a.34.34,0,0,0,.17-.64l-4-2.31a.34.34,0,1,0-.34.6l4,2.3A.26.26,0,0,0,186.31,355.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.28,363a.82.82,0,0,0,.38-.09.93.93,0,0,0,.41-.83v-.94a.35.35,0,1,0-.69,0v.94a.34.34,0,0,1-.06.23.32.32,0,0,1-.23-.06,2,2,0,0,1-.64-1.55V354.6a.35.35,0,0,0-.34-.35.35.35,0,0,0-.35.35v6.11a2.61,2.61,0,0,0,1,2.14A1,1,0,0,0,198.28,363Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.76,352.39v-.2a2.92,2.92,0,0,1,4.75-2.74,9.74,9.74,0,0,1,4.39,7.62v.6Zm1.76-2.64a2.56,2.56,0,0,0-1.07,2.25l7.73,4.46a9.07,9.07,0,0,0-4-6.41,3.54,3.54,0,0,0-1.71-.53A1.89,1.89,0,0,0,194.52,349.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1,370.72a.35.35,0,0,0,.35-.34v-11.7a.35.35,0,0,0-.35-.34.34.34,0,0,0-.34.34v11.7A.34.34,0,0,0,212.1,370.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.11,361.35a.35.35,0,0,0,.14,0,.34.34,0,0,0,.17-.45L212.2,358l-1.36,1.58a.34.34,0,0,0,0,.48.36.36,0,0,0,.49,0l.64-.75.79,1.82A.36.36,0,0,0,213.11,361.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.92,368.91a.35.35,0,0,0,.35-.34v-11.7a.35.35,0,0,0-.35-.35.35.35,0,0,0-.34.35v11.7A.34.34,0,0,0,208.92,368.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.93,359.53a.34.34,0,0,0,.14,0,.36.36,0,0,0,.18-.46L209,356.23l-1.36,1.57a.34.34,0,1,0,.52.45l.64-.75.79,1.83A.35.35,0,0,0,209.93,359.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.43,333.38v15.14c0,.59-.41.82-.91.53L188.87,335.4a2,2,0,0,1-.92-1.59V318.66c0-.59.4-.82.91-.53l23.65,13.66A2,2,0,0,1,213.43,333.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.42 320.3 190.18 320.74 190.18 334.51 189.42 334.07 189.42 320.3",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.53 322.09 193.84 322.87 193.84 336.64 192.53 335.86 192.53 322.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.64 323.89 196.4 324.33 196.4 338.1 195.64 337.66 195.64 323.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.98 325.21 199.51 326.12 199.51 339.89 197.98 338.99 197.98 325.21",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.85 327.47 202.62 327.92 202.62 341.69 201.85 341.25 201.85 327.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.09 328.74 205.72 329.71 205.72 343.48 204.09 342.51 204.09 328.74",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.07 331.06 208.83 331.5 208.83 345.27 208.07 344.83 208.07 331.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.84 332.07 210.22 332.29 210.22 346.06 209.84 345.84 209.84 332.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.65 330.31 207.03 330.53 207.03 344.3 206.65 344.08 206.65 330.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.39 326.64 200.77 326.87 200.77 340.63 200.39 340.42 200.39 326.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.96 324.68 197.34 324.9 197.34 338.67 196.96 338.45 196.96 324.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.5 323.32 194.88 323.54 194.88 337.31 194.5 337.09 194.5 323.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.16 321.29 191.54 321.51 191.54 335.28 191.16 335.06 191.16 321.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.18 332.86 211.94 333.3 211.94 347.07 211.18 346.63 211.18 332.86",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-17",
    points: "338.17 376.27 271.36 414.8 220.06 385.26 287.02 346.82 338.17 376.27",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "227.81 325.62 288.75 290.44 333.43 316.24 272.5 351.42 227.81 325.62",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "227.81 325.62 288.75 290.44 333.43 316.24 272.5 351.42 227.81 325.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.15,295.5l-18.7,10.77c-.34.2-.25.57.2.83l21.12,12.19a1.6,1.6,0,0,0,1.43.11l18.7-10.77c.34-.2.25-.57-.2-.83l-21.12-12.18A1.57,1.57,0,0,0,288.15,295.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.6,313.83a.39.39,0,0,0,.33-.19.38.38,0,0,0-.14-.53L280.26,303a.39.39,0,0,0-.38.67l17.52,10.12A.49.49,0,0,0,297.6,313.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.65,315a.39.39,0,0,0,.34-.2.4.4,0,0,0-.15-.53L278.32,304.1a.39.39,0,0,0-.53.15.38.38,0,0,0,.14.52l17.53,10.12A.35.35,0,0,0,295.65,315Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.71,316.06a.39.39,0,0,0,.19-.72l-17.53-10.12a.39.39,0,0,0-.53.14.4.4,0,0,0,.14.53L293.51,316A.46.46,0,0,0,293.71,316.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.76,317.18a.38.38,0,0,0,.33-.2.38.38,0,0,0-.14-.53l-17.53-10.11a.38.38,0,1,0-.38.66l17.53,10.12A.33.33,0,0,0,291.76,317.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.13 308.14 308.45 307.74 300.47 312.36 301.15 312.75 309.13 308.14",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.36 306.54 305.18 305.86 297.19 310.47 298.38 311.15 306.36 306.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.58 304.93 302.9 304.54 294.92 309.15 295.6 309.54 303.58 304.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.51 303.72 300.13 302.94 292.14 307.55 293.52 308.33 301.51 303.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.04 301.73 297.35 301.33 289.37 305.94 290.05 306.34 298.04 301.73",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.05 300.56 294.58 299.73 286.6 304.34 288.07 305.18 296.05 300.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.49 298.52 291.81 298.13 283.82 302.74 284.5 303.13 292.49 298.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.91 297.61 290.57 297.41 282.59 302.02 282.93 302.21 290.91 297.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.71 299.28 293.37 299.08 285.39 303.69 285.73 303.89 293.71 299.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.33 302.49 298.99 302.29 291.01 306.9 291.35 307.1 299.33 302.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.39 304.26 302.05 304.06 294.06 308.67 294.4 308.87 302.39 304.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.55 305.55 304.21 305.35 296.23 309.96 296.56 310.16 304.55 305.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.59 307.24 307.25 307.04 299.26 311.65 299.6 311.85 307.59 307.24",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.71 296.92 289.03 296.53 281.05 301.14 281.73 301.53 289.71 296.92",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.5 410.77 227.81 384.97 227.81 325.62 272.5 351.42 272.5 410.77",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.5 410.77 227.81 384.97 227.81 325.62 272.5 351.42 272.5 410.77",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.5 410.77 333.43 375.59 333.43 316.24 272.5 351.42 272.5 410.77",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.5 410.77 333.43 375.59 333.43 316.24 272.5 351.42 272.5 410.77",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.99 341.83 299.08 345.25 299.08 336.07 304.99 332.66 304.99 341.83",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.08 336.07 254.4 310.27 260.31 306.86 304.99 332.66 299.08 336.07",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.79,369.88a1,1,0,0,1-.44-.11,1.36,1.36,0,0,1-.55-1.23v-3.6h0v-.26l.18,0,2.83-1.66v4a3.26,3.26,0,0,1-1.39,2.63A1.32,1.32,0,0,1,327.79,369.88Zm-.54-4.67v3.33a.92.92,0,0,0,.33.83.61.61,0,0,0,.61-.07,2.84,2.84,0,0,0,1.16-2.23v-.3h-1l-.21-1.41Zm1.45,1.11h.65v-2.49l-1.68,1,.83.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.3,372.75a.22.22,0,0,1-.22-.22v-3a.23.23,0,1,1,.45,0v3A.22.22,0,0,1,328.3,372.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,373.51a.23.23,0,0,1-.2-.11.23.23,0,0,1,.08-.31l2.63-1.52a.23.23,0,0,1,.31.08.22.22,0,0,1-.08.31l-2.63,1.52A.23.23,0,0,1,327,373.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.1,378.19a.54.54,0,0,1-.25-.06.61.61,0,0,1-.27-.55V377a.23.23,0,0,1,.23-.23.24.24,0,0,1,.23.23v.62c0,.1,0,.14,0,.15s.07,0,.15,0a1.34,1.34,0,0,0,.42-1v-4a.23.23,0,1,1,.45,0v4a1.73,1.73,0,0,1-.64,1.41A.63.63,0,0,1,319.1,378.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.72,374.67v-.39a6.39,6.39,0,0,1,2.89-5,1.92,1.92,0,0,1,3.13,1.8v.13ZM321,369.3a2.33,2.33,0,0,0-1.13.35,6,6,0,0,0-2.65,4.22l5.09-2.94a1.65,1.65,0,0,0-.7-1.47A1.13,1.13,0,0,0,321,369.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,383.27a.22.22,0,0,1-.22-.22v-7.71a.23.23,0,1,1,.45,0v7.71A.22.22,0,0,1,310,383.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.33,377.09h-.09a.25.25,0,0,1-.12-.3l.81-1.86.9,1a.23.23,0,0,1-.34.3l-.43-.49-.52,1.2A.23.23,0,0,1,309.33,377.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.09,382.08a.23.23,0,0,1-.23-.23v-7.71a.24.24,0,0,1,.23-.23.23.23,0,0,1,.23.23v7.71A.23.23,0,0,1,312.09,382.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.43,375.9l-.09,0a.22.22,0,0,1-.12-.3l.81-1.86.89,1a.22.22,0,0,1,0,.32.23.23,0,0,1-.32,0l-.42-.5-.53,1.2A.21.21,0,0,1,311.43,375.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,386.24v15.15c0,.58.41.82.91.53l23.65-13.65a2,2,0,0,0,.92-1.59V371.52c0-.58-.41-.82-.92-.52l-23.65,13.66A2,2,0,0,0,277.3,386.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.31 373.17 300.55 373.61 300.55 387.38 301.31 386.94 301.31 373.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.2 374.96 296.89 375.73 296.89 389.5 298.2 388.73 298.2 374.96",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.1 376.75 294.33 377.19 294.33 390.96 295.1 390.52 295.1 376.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.75 378.08 291.22 378.99 291.22 392.76 292.75 391.85 292.75 378.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.88 380.34 288.12 380.78 288.12 394.55 288.88 394.11 288.88 380.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.64 381.6 285.01 382.57 285.01 396.35 286.64 395.37 286.64 381.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.66 383.93 281.9 384.37 281.9 398.14 282.66 397.7 282.66 383.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.89 384.94 280.51 385.16 280.51 398.93 280.89 398.71 280.89 384.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.08 383.18 283.7 383.4 283.7 397.17 284.08 396.95 284.08 383.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.34 379.51 289.96 379.73 289.96 393.5 290.34 393.28 290.34 379.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.77 377.54 293.39 377.76 293.39 391.53 293.77 391.31 293.77 377.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.23 376.18 295.85 376.4 295.85 390.17 296.23 389.95 296.23 376.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.57 374.15 299.19 374.38 299.19 388.15 299.57 387.93 299.57 374.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.55 385.72 278.79 386.16 278.79 399.93 279.55 399.49 279.55 385.72",
    style: {
      fill: "#455a64"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Botom--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.41,362.25c.33-5.31,3.18-58.8,3.18-58.8l-26,18.34c4.54,30.57,5.54,39.79,5.73,44.89h0a4.33,4.33,0,0,0-.12,1.31c.14,6.06,7.4,9.23,13.09,13.19a106,106,0,0,0,15.35,9.2c4.12,1.89,12.4,1.95,13.38-.56-6.92-4.86-14.93-10.17-20.47-15.75C138.92,371.4,137,368.62,137.41,362.25Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,396.17c.35,0,.94,3.66-.93,5.25-2.16,1.83-8.55,4.87-17.08,3.95s-13.2-3.37-16.66-6-8.3-6.42-12.17-7.17c-3.59-.7-7.51-2.18-8.67-3.22s-1.1-5.71-1.1-5.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.26,365.2a1.35,1.35,0,0,0-1.27,1.11c-.24,1.3-.45,5.05-1,7.17-.73,2.95-1.14,9-.63,11.37s6.38,4,10.14,5.26a48.19,48.19,0,0,1,12.21,7.08c4.06,3.08,12.54,6.11,18.09,6.1,8.47,0,13.92-2.26,15.56-5.18,2-3.61.35-5.66-9.47-9.81-1.86-.79-8.4-4.34-10.64-5.63-6-3.48-12-8.37-14.91-14.65a3.53,3.53,0,0,0-1.43-1.92A3.23,3.23,0,0,0,135,366a16.75,16.75,0,0,0-4.66,1.41c-1.3.61-3.14,1.32-3.08,2.91a5.14,5.14,0,0,0,.4,1.62c.12.32.22.75-.07.95s-.66,0-.92-.23a25.94,25.94,0,0,1-2.68-3,9.12,9.12,0,0,0-1.57-1.47,18.78,18.78,0,0,1-1.69-1C120.17,366.64,120.3,366,120.26,365.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5,389c-12.25,1-16,8.24-16.41,12.7a29.94,29.94,0,0,0,8.74,1.61c8.47,0,14.27-2.26,15.91-5.18C175.65,394.7,174.26,392,165.5,389Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,389.36a.68.68,0,0,1-.38-.12.56.56,0,0,1-.1-.8,14.79,14.79,0,0,1,11-4.32.58.58,0,0,1,.54.62.59.59,0,0,1-.65.52,13.67,13.67,0,0,0-10,3.89A.57.57,0,0,1,147.11,389.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,386.51a.64.64,0,0,1-.38-.12.54.54,0,0,1-.1-.8,14.69,14.69,0,0,1,11-4.32.58.58,0,0,1,.54.62.6.6,0,0,1-.65.52,13.58,13.58,0,0,0-10,3.89A.64.64,0,0,1,141.78,386.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.82,383.24a.66.66,0,0,1-.38-.12.55.55,0,0,1-.1-.8,14.73,14.73,0,0,1,11-4.32.57.57,0,1,1-.11,1.13,13.68,13.68,0,0,0-10,3.89A.61.61,0,0,1,136.82,383.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,380a.56.56,0,0,1-.37-.11.55.55,0,0,1-.12-.8c2.3-2.86,7.57-4.79,12-4.39a.58.58,0,0,1,.54.62.59.59,0,0,1-.65.51c-4-.35-8.94,1.42-11,3.95A.59.59,0,0,1,132,380Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.58,319.21l-27.1-5.86c-.71,16.77-.28,39.47-.85,55.21-.11,3-1.65,23-.79,29.14,1.28,9.24,13.67,8.64,14.69,3.2s1.92-28.69,2.13-31.1c.57-10.09,6.33-27,10.36-45C93.22,323.93,94.39,320.07,94.58,319.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.91,405c-.11,5.39-.89,9-2.91,12.22s-6,4.37-10.22,3.6-9.58-3-11-7.63-1.3-7.78-.59-12.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.69,366.63c-1.7.19-1.87,7.42-2.52,14.68-.7,7.79-3.17,11.09-3.82,17.47-.74,7.3-.16,10.53,2.92,14.81s13.49,8.2,18.23,1.73c3.86-5.27,3.77-11,3.07-18.19-.74-7.48-1.32-12.73-1.23-18.43.08-5.44,1-10.51-.49-11.06-.07.8-.14,1.82-.22,2.6-.07.61-.1,3.56-1,3.62a10,10,0,0,1-.12-2.05,2.22,2.22,0,0,0-.54-1.73,6.59,6.59,0,0,0-2.68-.89c-1.69-.23-3.39-.43-5.1-.5-.85,0-1.7,0-2.55,0a7.8,7.8,0,0,0-2.15.35,1.44,1.44,0,0,0-.88.77,2,2,0,0,0,0,.84,5.35,5.35,0,0,1-.15,1.49c0,.22-.21.49-.45.44s-.29-.25-.3-.42c0-.88,0-1.52,0-2.54,0-.47.06-1.12,0-1.59S66.67,367.1,66.69,366.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.07,403c-.09,4.51.34,7.59,2.76,10.94,3.08,4.28,14.31,8.19,19,1.72,2.36-3.22,2.86-6.94,3-10.73C81.67,400.21,64.63,398.71,60.07,403Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.18,397.22a.8.8,0,0,1-.21-.05,28.06,28.06,0,0,0-14.75-.79.64.64,0,0,1-.77-.39.54.54,0,0,1,.44-.68,28.82,28.82,0,0,1,15.58.84.53.53,0,0,1,.33.73A.66.66,0,0,1,80.18,397.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.39,391a.62.62,0,0,1-.55-.36.53.53,0,0,1,.36-.72c7.53-2.56,15.22.58,15.55.72a.53.53,0,0,1,.3.74.67.67,0,0,1-.84.26c-.08,0-7.55-3.07-14.56-.68A.75.75,0,0,1,65.39,391Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.59,385.84a.65.65,0,0,1-.55-.34.55.55,0,0,1,.35-.73,21.92,21.92,0,0,1,15.86.66.52.52,0,0,1,.25.76.68.68,0,0,1-.86.22,20.84,20.84,0,0,0-14.77-.61A.55.55,0,0,1,65.59,385.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,380.09a.63.63,0,0,1-.55-.33.54.54,0,0,1,.34-.73c7.74-2.89,15.65.65,16,.81a.52.52,0,0,1,.26.75.68.68,0,0,1-.85.24c-.08,0-7.71-3.46-14.9-.78A.55.55,0,0,1,65.85,380.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.86,181.8c-.64,30.52-6.09,98.31-6.09,98.31-.46,3.75-5.89,19.69-6.09,33.25-.31,21.27-.77,37.38-.77,37.38s11.89,4.71,20.62,1.45c0,0,11.35-45.22,14.54-59.33,3.79-16.81,13.25-48.06,13.25-48.06l-.69,44.42a122.09,122.09,0,0,0-.35,26.86c1,9,4.64,33.91,4.64,33.91s10.94,2.21,20.42-.6c0,0,5.71-53.58,6.18-61.82.54-9.4,3.44-103.94,3.44-103.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.32,244.8l4.25-28.32s10.37-.41,17.48-7.07c0,0-.89,6.65-13.86,10.65l-4.91,23.88-3.8,44.45Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.83,92.82c5.51-.29,15.77-.64,23.15,8.44,5.18,6.38,19.31,21.73,27.32,31.87,5.37-5.59,18.38-19.13,20.52-23.09a62.54,62.54,0,0,0,4.86-11.65,41.36,41.36,0,0,0,1.71-7.27,39.63,39.63,0,0,0,.15-9.11c-.06-2.75,4-1.34,5.6,3a23.86,23.86,0,0,1,1.19,7.48c1.52-.72,5.93-2.89,6.61-3.2,2.4-1.12,10-3.79,10.74.5.17,1-.14,2,.28,2.89a6.42,6.42,0,0,0,.84,1.12,4.9,4.9,0,0,1,.59,5,3.9,3.9,0,0,0-.41,2.28,6.23,6.23,0,0,1,.1,2.47,9.81,9.81,0,0,1-1,1.77,7.57,7.57,0,0,0-.66,2.53,9.71,9.71,0,0,1-.58,2.56c-.84,1.9-3.14,2.34-4.91,3A84.05,84.05,0,0,0,221,116.5c-4.24,2.8-15.69,23.5-27.28,36.76-4,4.55-7.53,7.39-11.3,6.9l0,0c-3.05-.07-6.82-2.83-10.45-6-11.55-10-30.1-29.58-30.1-29.58C134.13,115.19,132,99.12,132.83,92.82Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,91.28c3.66.57,6.18.46,10.84,3.11,4.1,2.32,5.57,4.29,10.32,9.6s16.1,19.11,16.1,19.11-4.83,11.55-19.79,15.74l-16.56-16.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4,92.93c-2.36.83-3,2.43-2.78,5.85.1,2-.38,5.8-2.54,7.38a5.24,5.24,0,0,0,2.84-1.34c1-1.11,1.29-1.24,1.88-.64a3.82,3.82,0,0,0,1.56.82,2.65,2.65,0,0,0-.15,3.15c1.12,1.73,5.88,1.61,9.71-.53,0,0-6.26,2.17-7.79.21s1.74-4.59,4.21-5.35c0,0-6.06,1.65-7.06-.33s1.48-3.57,5-4.6c0,0-5,1.08-5.94-.61C218.27,94.89,219.76,93.63,220.4,92.93Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,94.41s-5.87,5.16-7.37,10.74c-.74,2.74-1.41,5,.91,20.25,2.21,14.53,2.2,18.88,2.71,30.2L78.57,186c8.7,10.18,50.87,15.72,71.17,2,0,0,.12-52.62-1.32-70-1-11.78-4.58-22.84-8.64-26.46-5.51-1-10.82-1.6-10.82-1.6l-20.3-1.18Z",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.17,52.22c2.71-6.2.06-14.43-3.17-18.29-4.67-5.58-11.94-8-22.9-7.31-8.33.52-16.53,4-18.09,12.53-6.7,2-5.93,13-4.27,17.85,3.38,9.84,10,18.41,10.14,23.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.17,75.38c-1.32,4.75-4.07,8.24-8.47,8.93a37.13,37.13,0,0,1-6.94,0l.18,6.06c5.91,5.06,3.74,11.71-.2,17.7-4.91-5.45-10.52-7.39-15.42-9.55a15.72,15.72,0,0,1-7.14-6.92l-.63-20.44s-2.69,3.06-7.12.17a9.67,9.67,0,0,1-3-11.85c2.19-4.63,6.59-2.72,8-1.31s2.93,4.06,4.06,3.69a4.11,4.11,0,0,0,2.73-2.78,25,25,0,0,0,1.43-9A12.08,12.08,0,0,0,110,47.46a11.1,11.1,0,0,0,3-6.88c9.5-3,20.43-1.57,24.38,1.49,2.27,4,2.35,13.3,2.73,18.66C140.53,66.55,140.27,71.41,139.17,75.38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.76,84.34c-4.86-.27-14.64-2.54-17.24-5.26s-3.71-8.26-3.71-8.26.39,7,2.4,10.1,7.1,4.45,10.19,5.21a76.27,76.27,0,0,0,8.45,1.29Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.73,108.1c-2.54-1.56-8.15-7.93-11-5s-4.29,3.78-6.13,3.23-5.92-4.57-8.58-7.51a17.06,17.06,0,0,1-3.5-7.16,48.72,48.72,0,0,0,3.75-5.22c1.26-2.24,1-2.87,2.61-3l.14,4.23s1,2.31,5.6,5.43S120.45,100.91,123.73,108.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.73,108.1c1.52-1.38,4-7.83,4.64-7.64,1,.28,2.71,4.73,3.55,3.69,1.33-1.64.92-9.12-1.29-11.84s-5.15-5.62-6.81-5.9l.12,4a16.11,16.11,0,0,1,1.64,6.44C125.56,99.1,124.05,105.93,123.73,108.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.69,57.62a2,2,0,1,1-2-2A2,2,0,0,1,120.69,57.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94,51.34,114,54a2.51,2.51,0,0,1,.67-3.42A2.35,2.35,0,0,1,117.94,51.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,53.18l-4.37-2.09a2.33,2.33,0,0,1,3.16-1.19A2.53,2.53,0,0,1,137,53.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.54,57.5a2,2,0,1,1-2-2A2,2,0,0,1,135.54,57.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.2 53.4 126.62 67.53 134.21 65.24 125.2 53.4",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.68,70.82l8.13,1.8a4.09,4.09,0,0,1-4.88,3.3A4.35,4.35,0,0,1,120.68,70.82Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.93,75.92a3,3,0,0,0,.51.06,3.78,3.78,0,0,0-3.78-3.69A4.3,4.3,0,0,0,123.93,75.92Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "189.56 139.52 136.41 149.92 116.79 213.79 167.42 202.56 189.56 139.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,187.6a12.24,12.24,0,0,1-8.61,8.87c-7,1.84-14.26-.84-14.26-.84l1.64-5.34Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.65,147.93l.56-2c.31-1.08-2.75-1.33-6.84-.54l-7.83,1.5c-4.09.78-7.66,2.3-8,3.38l-.56,2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.76,140.64c.2-.67-1-.94-2.75-.58l-3.1.65s1.19-4.26-5.68-3.19-8.66,5.88-8.66,5.88l-3.31.71c-1.83.4-3.53,1.26-3.78,1.93l-.47,1.22,27.38-5.36S177.57,141.32,177.76,140.64Z",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.76,140.64c.2-.67-1-.94-2.75-.58l-3.1.65s1.19-4.26-5.68-3.19-8.66,5.88-8.66,5.88l-3.31.71c-1.83.4-3.53,1.26-3.78,1.93l-.47,1.22,27.38-5.36S177.57,141.32,177.76,140.64Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.89,150.51c.26-.9,2.77-2.1,6-2.92,0-.12.06-.23.09-.32.24-1-.13-1.55-2.06-1.17l-.11-.77,19-3.55-.83.78c-2.51.43-3.56.7-4,2.37l-.11.38c3-.34,5,0,4.75.86l-.56,2-22.64,4.34Z",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.89,150.51c.26-.9,2.77-2.1,6-2.92,0-.12.06-.23.09-.32.24-1-.13-1.55-2.06-1.17l-.11-.77,19-3.55-.83.78c-2.51.43-3.56.7-4,2.37l-.11.38c3-.34,5,0,4.75.86l-.56,2-22.64,4.34Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2,176.66c6.5,2.18,13,2.34,19.76,2.33,1.65,0,2.9.25,3.39,1.82.17.56.4,1.33-1.73,2a3,3,0,0,0-1.66.86c-.49.78-.25,1.56-.38,2.47a6.91,6.91,0,0,1-2,3.45,16.19,16.19,0,0,1-3.34,3.12c-4.12,2.59-10.47,2.91-15.16,2.15a50.92,50.92,0,0,1-9.35-2.76c-2.87-1.06-20.3-6.2-22.37-6.92-15.39-5.37-36.55-12-37.8-19.25s2.67-30,5.47-48.54c2.26-15,8.33-20.3,18.16-22.35,10.78,12.24,4,33.45,4,33.45l-3.92,28.26c1.66,1.38,26.84,15.51,31.19,16.92,1.57.51,4.53-.11,6.1-.65,4.2-1.43,7.09-1.31,11.16-1.13",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,94.41C71.3,95.84,65.12,101.19,63,111.31c-1.77,8.5-5.06,35.95-5.06,35.95,6.94,6.12,18.33,5.79,24.5,3.65l3.18-22C88.19,123.22,92.21,106.39,81.75,94.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,183.58l-5.27,2.92a2.56,2.56,0,0,0-1.2,2c-.13,4.72-.51,20.95.24,29.84a2.87,2.87,0,0,0,1.28,2c3,1.69,11.14,6.15,14.87,7.18a4.62,4.62,0,0,0,2.54-.28l3.76-1.5a2.14,2.14,0,0,0,1.22-1.83c0-9.43,1.67-19.81,3.23-30.09a1.91,1.91,0,0,0-1-1.89L77.4,183.52A2.9,2.9,0,0,0,75,183.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.81,218.31c-.75-8.89-.37-25.11-.24-29.84a.78.78,0,0,1,1.23-.74l16.11,8A2.1,2.1,0,0,1,87,197.65a253.39,253.39,0,0,0-.79,28.7A1,1,0,0,1,85,227.46c-3.73-1-11.85-5.49-14.87-7.18A2.87,2.87,0,0,1,68.81,218.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.16,227.49a4.74,4.74,0,0,0,2.34-.31l3.76-1.51a2.18,2.18,0,0,0,1.21-1.82c.74-9.69,1.67-19.81,3.24-30.09a1.65,1.65,0,0,0-.19-1l-8.72,4a1.85,1.85,0,0,1,.19.94,248.77,248.77,0,0,0-.79,28.71A1,1,0,0,1,85.16,227.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7,191.82l11.83,5.72-.62,9.64L71.37,202.1S71.45,195.9,71.7,191.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,206.44,72,201.63s.07-5.47.29-9.51l11.21,5.42Z",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,206.44,72,201.63s.07-5.47.29-9.51l11.21,5.42Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.5 191.21 85.56 192.62 74.96 187.43 77.82 185.99 88.5 191.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.06 191.42 85.56 192.62 75.41 187.64 77.83 186.42 88.06 191.42",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.06 191.42 85.56 192.62 75.41 187.64 77.83 186.42 88.06 191.42",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.55 190.68 84.03 191.86 83.71 191.71 86.22 190.52 86.55 190.68",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.29 189.57 81.8 190.77 81.43 190.59 83.95 189.41 84.29 189.57",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.04 188.48 79.53 189.66 79.21 189.51 81.71 188.32 82.04 188.48",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.99 187.48 77.48 188.66 77.16 188.5 79.66 187.31 79.99 187.48",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.42,210.47l-.09,1.18a.45.45,0,0,1-.66.41l-2.14-.87a1,1,0,0,1-.57-.92l.07-1.22a.44.44,0,0,1,.65-.4l2.17.9A1,1,0,0,1,83.42,210.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.44,214.34l-.07,1.19a.45.45,0,0,1-.65.42l-2.15-.85a1,1,0,0,1-.59-.9L80,213a.44.44,0,0,1,.64-.42l2.19.87A1,1,0,0,1,83.44,214.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.46,218.21l0,1.19a.45.45,0,0,1-.65.43L80.6,219a1,1,0,0,1-.6-.9l0-1.22a.44.44,0,0,1,.64-.42l2.19.83A1,1,0,0,1,83.46,218.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.48,222.08l0,1.19a.45.45,0,0,1-.64.44l-2.18-.78a1,1,0,0,1-.62-.88l0-1.22a.44.44,0,0,1,.63-.44l2.21.8A1,1,0,0,1,83.48,222.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.63,208.28l-.07,1.24a.43.43,0,0,1-.64.41l-2.13-.88a1,1,0,0,1-.59-.92l.06-1.27a.42.42,0,0,1,.63-.4l2.16.9A1,1,0,0,1,78.63,208.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.61,212.13l-.06,1.23a.44.44,0,0,1-.64.42l-2.13-.87a1,1,0,0,1-.59-.92l0-1.27a.43.43,0,0,1,.64-.4l2.16.89A1,1,0,0,1,78.61,212.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,216l0,1.24a.43.43,0,0,1-.64.41l-2.14-.86a1,1,0,0,1-.59-.91l0-1.27a.43.43,0,0,1,.63-.41l2.17.89A1,1,0,0,1,78.59,216Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.58,219.81l0,1.24a.44.44,0,0,1-.64.42l-2.14-.85a1,1,0,0,1-.6-.91l0-1.27a.43.43,0,0,1,.63-.41l2.17.87A1,1,0,0,1,78.58,219.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.83,206.1l0,1.29a.42.42,0,0,1-.63.4l-2.11-.88a1,1,0,0,1-.6-.92l0-1.32a.42.42,0,0,1,.62-.4l2.15.9A1,1,0,0,1,73.83,206.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.85,209.84l0,1.29a.42.42,0,0,1-.63.4l-2.11-.88a1,1,0,0,1-.6-.92l0-1.32a.42.42,0,0,1,.63-.4l2.14.9A1.06,1.06,0,0,1,73.85,209.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86,213.57l0,1.29a.43.43,0,0,1-.64.41l-2.11-.88a1,1,0,0,1-.59-.92l0-1.32a.41.41,0,0,1,.62-.4l2.14.9A1.05,1.05,0,0,1,73.86,213.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,217.31l0,1.29a.42.42,0,0,1-.63.41l-2.11-.88a1,1,0,0,1-.6-.92l0-1.32a.42.42,0,0,1,.63-.4l2.14.9A1,1,0,0,1,73.87,217.31Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288,89.08l-12.37,7.17,4.91,11a1.14,1.14,0,0,0,.47.52l4.25,2.46a1.14,1.14,0,0,0,1.66-.66l5.33-18.07Z",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,89.08l-12.37,7.17,4.91,11a1.14,1.14,0,0,0,.47.52l4.25,2.46a1.14,1.14,0,0,0,1.66-.66l5.33-18.07Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.92,98.7l4.91,11a1.13,1.13,0,0,0,2.12-.14l5.33-18.07Z",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,19.52,257,46.45a2.36,2.36,0,0,0-1.07,1.85v57.88A2.35,2.35,0,0,0,257,108l3.84,2.15a2.39,2.39,0,0,0,2.15,0l46.63-26.93a2.34,2.34,0,0,0,1.07-1.85V23.5a2.35,2.35,0,0,0-1.07-1.84l-3.84-2.15A2.4,2.4,0,0,0,303.6,19.52Z",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.64,23.31c-.08-.54-.52-.73-1.06-.42L263,49.81a2.17,2.17,0,0,0-.76.8l-6-3.4a2.16,2.16,0,0,1,.74-.76L303.6,19.52a2.37,2.37,0,0,1,2.14,0l3.84,2.15A2.34,2.34,0,0,1,310.64,23.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.88,109.54V51.67A2.34,2.34,0,0,1,263,49.81l46.63-26.92c.6-.34,1.07-.07,1.07.61V81.38a2.34,2.34,0,0,1-1.07,1.85L263,110.16C262.35,110.5,261.88,110.22,261.88,109.54Z",
    style: {
      fill: "#EAEAEA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,110.16a2.46,2.46,0,0,1-2.15,0L257,108a2.33,2.33,0,0,1-1.07-1.84V48.3a2.14,2.14,0,0,1,.34-1.09l6,3.4a2.11,2.11,0,0,0-.32,1.06v57.87C261.88,110.16,262.32,110.52,263,110.16Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--check-list--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.87,67.78a.53.53,0,0,1-.54-.53V57.17a.52.52,0,0,1,.27-.46l8.73-5a.51.51,0,0,1,.53,0,.52.52,0,0,1,.27.46V62.21a.53.53,0,0,1-.26.46l-8.73,5A.54.54,0,0,1,266.87,67.78Zm.54-10.3v8.84l7.65-4.42V53.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-17",
    d: "M276.62,49.61a1.06,1.06,0,0,0-1.39.56l-4,9.52-1-.93a1.06,1.06,0,1,0-1.48,1.52l2.07,2a1.07,1.07,0,0,0,.74.3l.21,0a1.06,1.06,0,0,0,.76-.63L277.18,51A1,1,0,0,0,276.62,49.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,51.37l22.26-12.85c.77-.45,1.4-.13,1.4.71a3,3,0,0,1-1.4,2.33L283,54.41c-.77.44-1.39.12-1.39-.72A3,3,0,0,1,283,51.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.87,82.9a.5.5,0,0,1-.27-.07.55.55,0,0,1-.27-.47V72.29a.53.53,0,0,1,.27-.47l8.73-5a.55.55,0,0,1,.53,0,.55.55,0,0,1,.27.47V77.32a.53.53,0,0,1-.27.47l-8.72,5A.54.54,0,0,1,266.87,82.9Zm.53-10.3v8.83L275.06,77V68.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--check--inject-17",
    d: "M276.62,64.72a1.07,1.07,0,0,0-1.39.57l-4,9.52-1-.93a1.06,1.06,0,0,0-1.5,0,1.08,1.08,0,0,0,0,1.5l2.07,2a1,1,0,0,0,.74.3.75.75,0,0,0,.21,0,1,1,0,0,0,.76-.62l4.6-11A1.06,1.06,0,0,0,276.62,64.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,66.44l22.26-12.85c.77-.45,1.4-.13,1.4.71a3,3,0,0,1-1.4,2.32L283,69.48c-.77.44-1.39.12-1.39-.72A3,3,0,0,1,283,66.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.87,98a.5.5,0,0,1-.27-.08.52.52,0,0,1-.27-.46V87.4a.52.52,0,0,1,.27-.46l8.73-5a.51.51,0,0,1,.53,0,.52.52,0,0,1,.27.46V92.44a.52.52,0,0,1-.27.46l-8.72,5A.56.56,0,0,1,266.87,98Zm.53-10.31v8.84l7.66-4.42V83.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--check--inject-17",
    d: "M276.62,79.84a1.06,1.06,0,0,0-1.39.56l-4,9.52-1-.93a1.06,1.06,0,0,0-1.48,1.52l2.07,2a1.07,1.07,0,0,0,.74.3l.21,0a1.06,1.06,0,0,0,.76-.63l4.6-11A1,1,0,0,0,276.62,79.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,81.51l22.26-12.86c.77-.44,1.4-.12,1.4.72a3,3,0,0,1-1.4,2.32L283,84.54c-.77.45-1.39.13-1.39-.71A3,3,0,0,1,283,81.51Z",
    style: {
      fill: "#455a64"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderSuccessfull);
export default __webpack_public_path__ + "static/media/Order Successfull.a070dda65075a504370ef334932ac833.svg";
export { ForwardRef as ReactComponent };